import { h, setChildren } from "../core/dom.js";
import { loadLibrary, muscles, muscleName } from "../store.js";
import { navigate } from "../core/router.js";
import { icon } from "../lib/icons.js";
import { topbar, backLink, exerciseThumb } from "../components/common.js";
import { spinner, errorState } from "../components/ui.js";

export default function Library() {
  const root = h("div", { class: "screen" });
  let library = [];
  const filters = { q: "", muscle: "", equipment: "", category: "" };
  const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

  load();
  async function load() {
    setChildren(root, backLink("Plan", "/workouts"), topbar("Exercises"), spinner());
    try {
      library = await loadLibrary();
      render();
    } catch (e) {
      setChildren(root, backLink("Plan", "/workouts"), topbar("Exercises"), errorState(e.message, load));
    }
  }

  function render() {
    const equipments = [...new Set(library.map((e) => e.equipment).filter(Boolean))].sort();
    const categories = [...new Set(library.map((e) => e.category).filter(Boolean))].sort();
    const newBtn = h("button", { class: "btn btn-primary", style: { padding: "8px 14px" }, onClick: () => navigate("/library/new") },
      icon("plus", { size: 16 }), "New");
    setChildren(root,
      backLink("Plan", "/workouts"),
      topbar("Exercises", { sub: `${library.length} in library`, actions: newBtn }),
      h(
        "div",
        { class: "hstack", style: { gap: "6px", marginBottom: "10px" } },
        icon("search", { size: 18, className: "icon muted" }),
        h("input", { class: "input", placeholder: "Search exercises…", oninput: (e) => { filters.q = e.target.value.toLowerCase(); renderList(); } })
      ),
      h(
        "div",
        { class: "chip-row", style: { marginBottom: "12px" } },
        sel("muscle", "All muscles", muscles().map((m) => [m.muscle_id, m.muscle])),
        sel("category", "All types", categories.map((c) => [c, cap(c)])),
        sel("equipment", "All equipment", equipments.map((e) => [e, e]))
      ),
      h("div", { id: "lib-list", class: "ex-list" })
    );
    renderList();
  }

  function sel(key, label, options) {
    return h(
      "select",
      { class: "select", style: { flex: "1", padding: "8px 10px" }, onchange: (e) => { filters[key] = e.target.value; renderList(); } },
      h("option", { value: "" }, label),
      ...options.map(([v, l]) => h("option", { value: v }, l))
    );
  }

  function renderList() {
    const list = root.querySelector("#lib-list");
    if (!list) return;
    const matches = library.filter((ex) => {
      if (filters.q && !ex.exercise_name.toLowerCase().includes(filters.q)) return false;
      if (filters.equipment && ex.equipment !== filters.equipment) return false;
      if (filters.category && ex.category !== filters.category) return false;
      if (filters.muscle) {
        const id = Number(filters.muscle);
        if (![...(ex.primary_muscle_ids || []), ...(ex.secondary_muscle_ids || [])].includes(id)) return false;
      }
      return true;
    });
    const shown = matches.slice(0, 120);
    setChildren(list, 
      ...shown.map((ex) =>
        h(
          "div",
          { class: "ex-row card-tap", onClick: () => navigate(`/exercise/${ex.id}`) },
          exerciseThumb(ex.images),
          h("div", { class: "ex-info" }, h("div", { class: "ex-name" }, ex.exercise_name), h("div", { class: "ex-meta" }, [ex.equipment, ex.level].filter(Boolean).join(" · "))),
          icon("forward", { size: 18, className: "icon muted" })
        )
      ),
      matches.length > shown.length ? h("p", { class: "dim center mt" }, `Showing ${shown.length} of ${matches.length} — refine your search`) : null,
      matches.length === 0 ? h("p", { class: "dim center mt" }, "No exercises match.") : null
    );
  }

  return root;
}
